import { render, staticRenderFns } from "./OfficeSales.vue?vue&type=template&id=a3181a1e&scoped=true&"
import script from "./OfficeSales.vue?vue&type=script&lang=js&"
export * from "./OfficeSales.vue?vue&type=script&lang=js&"
import style0 from "./OfficeSales.vue?vue&type=style&index=0&id=a3181a1e&lang=scss&scoped=true&"
import style1 from "./OfficeSales.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3181a1e",
  null
  
)

export default component.exports